export const styles = (theme) => ({
  alertTitle: {
    fontSize: 24
  },
  errorMessage: {
    color: theme.palette.error.main,
  }
})
